import { InjectionToken } from '@angular/core';

export const TT_COM_LESERFOTOS_API_ENDPOINT = new InjectionToken<string>('API Endpoint for TT-Leserfotos');
export const TT_COM_LESERFOTOS_BUCKET_ENDPOINT = new InjectionToken<string>('Bucket Endpoint for TT-Leserfotos');
export const TT_COM_LESERFOTOS_BUCKET_NAME = new InjectionToken<string>('Bucket Name for TT-Leserfotos');
export const TT_COM_LESERFOTOS_GALLERY_JSON_URL = new InjectionToken<string>('Url to gallery Json from assets.tt.com');
export const TT_COM_LESERFOTOS_FRONTEND_ENDPOINT = new InjectionToken<string>('Frontend Endpoint for TT-Leserfotos');
